module.exports = __webpack_public_path__ + "img/share_error_3.c1554780.svg";